export const myCaseDraftsTranslations = {
  my_case_drafts_header: 9911,
  my_case_drafts_tag: 9894,
  my_case_drafts_id: 9895,
  my_case_drafts_case_type: 9896,
  my_case_drafts_created_date: 9898,
  my_case_drafts_last_modified_date: 9897,
  my_case_drafts_title: 9899,
  my_case_drafts_description: 9900,
  my_case_drafts_case_date: 9901,
  my_case_drafts_delete: 9902,
  my_case_drafts_fail_to_load: 9903,
  my_case_drafts_fail_to_delete: 9904,
  my_case_drafts_no_results: 9905,
  my_case_drafts_delete_title: 9906,
  my_case_drafts_delete_description: 9907,
  my_case_drafts_delete_continue: 9908,
  my_case_drafts_delete_cancel: 9909
};

export type MyCaseDraftsTranslation = {
  readonly [T in keyof typeof myCaseDraftsTranslations]: string
};
